import { SearchForm } from '@calendly/form';
import { useOnValueChange, useQueryParams } from '@calendly/hooks';
import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import ScopeDropdown from 'components/home_bar/scope_dropdown';
import { FiltersButton } from 'features/event_types_filters';
import { isObjectLevelPermissionsAvailableSelector } from 'features/object_level_permissions';
import { isMultipleSelector } from 'selectors/current_organization';
import { useEventTypeListData } from '../data/meeting_types_hooks';
import { PollFiltersButton } from '../tab_content/polls/components/filter_button';
import { SULFiltersButton } from '../tab_content/single_use_links/filters';
const containerIsPhoneCss = "crlkyca";
const containerIsCompactCss = "c1ozgeif";
const containerIsCompactTwoItemCss = "cplahs5";
const containerCss = "ccyzoyn";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isCompactLayout = false,
    isCompactTwoItem = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone,
    [containerIsCompactCss]: isCompactLayout && !isPhone && !isCompactTwoItem,
    [containerIsCompactTwoItemCss]: isCompactLayout && !isPhone && isCompactTwoItem
  }, props.className)} />;
});
const gridWrapperIsPhoneCss = "g1rg0ws7";
const gridWrapperCss = "ggj0vnj";
const GridWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(gridWrapperCss, {
    [gridWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const searchFormWrapperIsPhoneCss = "s1tmwzc0";
const searchFormWrapperIsCompactCss = "s1se15oq";
const searchFormWrapperCss = "s1wxhn8i";
const SearchFormWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isCompactLayout = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(searchFormWrapperCss, {
    [searchFormWrapperIsPhoneCss]: isPhone,
    [searchFormWrapperIsCompactCss]: isCompactLayout && !isPhone
  }, props.className)} />;
});
const filterDropDown = (tabName, {
  iconOnly = false
} = {}) => {
  if (tabName === 'meeting_types') return <FiltersButton iconOnly={iconOnly} />;
  if (tabName === 'polls') return <PollFiltersButton />;
  if (tabName === 'single_use_links') return <SULFiltersButton />;
  return null;
};
export const SearchFilter = ({
  isCompactLayout = false
}) => {
  const {
    scopeType
  } = useEventTypeListData();
  const queryParams = useQueryParams();
  const {
    filter_term: initialValue
  } = queryParams;
  const isObjectLevelPermissionsAvailable = useSelector(isObjectLevelPermissionsAvailableSelector);
  const userHasObjectLevelPermissions = isObjectLevelPermissionsAvailable;
  const isSingleUserScope = scopeType === 'my_calendly' || scopeType === 'user_single';
  const [value, setValue] = useState();
  const history = useHistory();
  const isMultipleOrganization = useSelector(isMultipleSelector);
  const {
    pathname
  } = useLocation();
  const currentTabSelected = pathname.split('/')[3];
  const showFilterButton = isMultipleOrganization && userHasObjectLevelPermissions || ['polls', 'single_use_links'].includes(currentTabSelected);
  const hasScopeDropdown = isMultipleOrganization;
  useOnValueChange(value, () => {
    const newParams = {
      ...queryParams
    };
    delete newParams.page;
    if (value) {
      newParams.filter_term = value;
    } else {
      delete newParams.filter_term;
    }
    history.replace({
      search: buildQuery(newParams)
    });
  });
  let placeHolder;
  if (currentTabSelected === 'meeting_types') {
    if (isSingleUserScope) placeHolder = I18n.t('publisher.scheduling.meeting_types.search.placeholder');else placeHolder = I18n.t('publisher.scheduling.meeting_types.search.placeholder_multi_scope');
  } else if (currentTabSelected === 'polls') placeHolder = I18n.t('publisher.scheduling.polls.search.placeholder');else if (currentTabSelected === 'single_use_links') placeHolder = I18n.t('publisher.scheduling.single_use_links.search.placeholder');else placeHolder = I18n.t('publisher.event_types.filter');
  return <Container isCompactLayout={isCompactLayout} isCompactTwoItem={isCompactLayout && !hasScopeDropdown}>
      {hasScopeDropdown && <GridWrapper>
          <ScopeDropdown spacingTop={0} spacingBottom={0} />
        </GridWrapper>}
      <SearchFormWrapper isCompactLayout={isCompactLayout}>
        <SearchForm id="event-types-search" initialValue={initialValue} placeholder={placeHolder} aria-label={placeHolder} onSearch={setValue} data-calendly-label="search-field" spacingTop={0} spacingBottom={0} isFullSized={isCompactLayout} />
      </SearchFormWrapper>
      {showFilterButton && <GridWrapper>
          {filterDropDown(currentTabSelected, {
        iconOnly: isCompactLayout && hasScopeDropdown
      })}
        </GridWrapper>}
    </Container>;
};

require("./search_filter.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_filter.js");